<template>
  <div class="actuality-detail">
    <v-card class="cart">
      <v-card-title>
        <h1>{{ actuality.title }}</h1>
      </v-card-title>
      <v-card-subtitle>
        <h2>{{ actuality.subtitle }}</h2>
      </v-card-subtitle>

      <v-card-text>
        <strong>Description:</strong>
        <div v-html="actuality.description"></div>
      </v-card-text>

      <v-row>
        <v-col cols="12" sm="12" md="6" class="d-flex flex-column align-center">
          <v-img
            :src="actuality.imgUrl"
            :alt="actuality.title + ' Image'"
            max-width="300"
            max-height="200"
            class="mb-2"
          ></v-img>
        </v-col>

        <v-col cols="12" sm="12" md="6" class="d-flex flex-column align-center">
          <v-img
            :src="actuality.imgBannerUrl"
            :alt="actuality.title + ' Banner Image'"
            max-width="300"
            max-height="200"
            class="mb-2"
          ></v-img>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="cart">
      <v-card-title> Selectionner un livre </v-card-title>
      <v-form
        v-model="valid"
        @submit.prevent="addSelectedBook"
        ref="form"
        class="libraryBook-form"
      >
        <!-- Search Text Field -->
        <v-col>
          <v-menu
            v-model="menuVisible"
            :close-on-content-click="false"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="keyword"
                label="Titre"
                outlined
                @input="searchBooks"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>

            <!-- Dropdown for Search Results -->
            <v-list v-if="searchResults.length">
              <v-list-item-group>
                <v-list-item
                  v-for="book in searchResults"
                  :key="book.bookId"
                  @click="selectBook(book)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ book.titre }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-col>
        <v-btn color="primary" @click="addSelectedBook" class="btn"
          >Affecter un Livre</v-btn
        >
      </v-form>
    </v-card>
    <v-card class="cart">
      <v-card-title> Listes des livres </v-card-title>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        class="elevation-1"
        item-key="libraryBookId"
        :headers="headers"
        :items="bookMinResponseList"
      >
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-btn @click="deleteBook(item.libraryBookId)" icon>
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Constant from "@/utils/constants";

export default {
  data() {
    return {
      book: {
        libraryId: this.id,
        bookId: null,
        titre: "",
        description: "",
        // nbrPage: 0,
        price: "",
        quantity: "",
        levelId: null,
        categoryId: null,
        authorId: null,
        publishHouseId: null,
        listFileUrl: [],
        listFileId: [],
        createdBy: localStorage.getItem("ownerId"),
      },
      menuVisible: false,
      keyword: "",
      valid: false,
      actuality: {},
      bookMinResponseList: [],
      selectedBook: null, // To store the selected book
      searchResults: [],
      headers: [
        { text: "Titre", value: "titre" },
        { text: "Description", value: "description" },
        { text: "Nombre de Page", value: "nbrPage" },
        { text: "Categorie ", value: "categoryName" },
        { text: "Nom Auteur ", value: "authorName" },
        { text: "Maison d'édition", value: "publishHouseName" },
        { text: "Prix", value: "price" },

        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
    };
  },
  async created() {
    await this.fetchActualityDetails();
  },
  methods: {
    // Fetch actuality details by ID
    async fetchActualityDetails() {
      const actualityId = this.$route.params.id;
      try {
        const response = await axios.get(
          `${Constant.QORANI}actuality/get/${actualityId}`
        );
        this.actuality = response.data;
        this.bookMinResponseList = response.data.bookMinResponseList || [];
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des détails de l'actualité:",
          error
        );
      }
    },

    // Search books
    async searchBooks() {
      if (this.keyword.length < 3) {
        this.searchResults = [];
        return;
      }
      try {
        const response = await axios.get(
          `${Constant.QORANI}library/book/findByKeywordArticle/${this.keyword}`
        );
        this.searchResults = response.data;
      } catch (error) {
        console.error("Erreur lors de la recherche des livres:", error);
      }
    },

    // Select a book
    selectBook(book) {
      if (book) {
        this.selectedBook = book;
        this.keyword = book.titre || "";
        this.searchResults = [];
        this.menuVisible = false;

        console.log("Selected Book:", this.selectedBook);
      }
    },

    // Add selected book to actuality
    async addSelectedBook() {
      this.$refs.form.validate();
      if (!this.selectedBook) {
        alert("Please select a book first.");
        return;
      }

      const actualityId = this.$route.params.id;
      const bookId = this.selectedBook.libraryBookId;

      console.log("Adding Book ID:", bookId);

      try {
        const response = await axios.get(
          `${Constant.QORANI}actuality/addbook/${bookId}/to/${actualityId}`
        );
        console.log(response.data);
        this.bookMinResponseList.push(this.selectedBook);
        this.$refs.form.reset();
      } catch (error) {
        console.error("Error adding book:", error);
        alert(
          "Error adding book: " +
            (error.response ? error.response.data.message : error.message)
        );
      }
    },

    // Delete book from actuality
    async deleteBook(bookId) {
      try {
        const actualityId = this.$route.params.id;
        await axios.get(
          `${Constant.QORANI}actuality/removebook/${bookId}/from/${actualityId}`
        );

        // Update the local state to remove the book
        this.bookMinResponseList = this.bookMinResponseList.filter(
          (book) => book.libraryBookId !== bookId
        );
        alert("Livre supprimé avec succès !");
      } catch (error) {
        console.error("Erreur lors de la suppression du livre:", error);
        alert("Erreur lors de la suppression du livre.");
      }
    },
  },
};
</script>

<style scoped>
.actuality-detail {
  padding: 20px;
}
.cart {
  margin-bottom: 30px;
}

.btn {
  bottom: 15px;
  left: 15px;
}
</style>
